<template>
  <div>
    <b-container>
      <little-bar
        class="about-nav"
        goWay="name"
        :navlist="navlist"
        copyright="forum"
        @changeCurrent="changeCurrent"
        @subClick="clickSubItem"
      ></little-bar>
      <keep-alive>
        <router-view />
      </keep-alive>
    </b-container>
  </div>
</template>
<script>
import littleBar from "@/forumcomponents/littleBar";
export default {
  components: {
    littleBar,
  },
  data() {
    return {
      current: 0,
      currentName: "",
      watch: {
        $route: {
          handler(to) {
            this.$cookie.setCookie("execuTid", to.query.type);
          },
          immediate: true,
        },
      },
      navlist: [
        {
          // text: '简介',
          text: this.$t("lang.fminiAboutUs"),
          path: "/forum/about/intro", //简介,
        },
        {
          // text: '愿景使命',
          text: this.$t("lang.VandM"),
          path: "/forum/about/vision",
        },
        {
          // text: '科学委员会',
          text: this.$t("lang.Sciencecommittee"),
          path: "/forum/about/committee",
          sub: [
            {
              text: this.$t("lang.RotatingChair"),
              // text: '轮值主席',
              path: "/forum/about/executive?type=1",
            },
            {
              text: this.$t("lang.SubcommitteeChair"),
              // text: '奖项委员会主席',
              path: "/forum/about/list?type=1&childrenType=2",
            },
            {
              text: this.$t("lang.Members"),
              // text: '委员',
              path: "/forum/about/committee",
            },
            {
              text: this.$t("lang.FormerMembers"),
              // text: '往届委员',
              path: "/forum/about/list?type=1&childrenType=4",
            },
          ],
        },
        {
          text: this.$t("lang.Council"),
          // text: '理事会',
          path: "/forum/about/council",
          sub: [
            {
              text: this.$t("lang.RotatingChair"),
              // text: '轮值主席',
              path: "/forum/about/executive?type=2",
            },
            {
              text: this.$t("lang.ExecutiveCommittee"),
              // text: '执行委员会',
              path: "/forum/about/list?type=2&childrenType=2",
            },
            {
              text: this.$t("lang.MembersList"),
              // text: '成员',
              path: "/forum/about/council",
            },
          ],
        },
        {
          text: this.$t("lang.InstitutionalCouncil"),
          // text: '机构理事',
          path: "/forum/about/institutional",
        },
        {
          text: this.$t("lang.YouthCouncil"),
          // text: '青年理事',
          path: "/forum/about/YouthCouncil",
          sub: [
            {
              text: this.$t("lang.RotatingChair"),
              // text: '轮值主席',
              path: "/forum/about/executive?type=4",
              params: "4",
            },
            {
              text: this.$t("lang.ExecutiveCommittee"),
              // text: '执行委员会',
              path: "/forum/about/list?type=4&childrenType=2",
            },
            {
              text: this.$t("lang.MembersList"),
              // text: '成员',
              path: "/forum/about/YouthCouncil",
            },
            {
              text: this.$t("lang.FormerMembers"),
              // text: '往届委员',
              path: "/forum/about/list?type=4&childrenType=4",
            },
          ],
        },
        {
          text: this.$t("lang.YOSIA"),
          // text: '青创联盟',
          path: "/forum/about/YOSIA",
          sub: [
            {
              text: this.$t("lang.RotatingChair"),
              // text: '轮值主席',
              path: "/forum/about/executive?type=5",
            },
            {
              text: this.$t("lang.ExecutiveCommittee"),
              // text: '执行委员会',
              path: "/forum/about/list?type=5&childrenType=2",
            },
            {
              text: this.$t("lang.MembersList"),
              // text: '成员',
              path: "/forum/about/YOSIA",
            },
          ],
        },
      ],
    };
  },
  created() {
    this.current = this.$route.query.index;
  },
  methods: {
    changeCurrent(index, path, type) {
      this.$router.push({
        path: path,
        query: {
          index: index,
        },
      });
    },
    clickSubItem(path) {
      this.$router.push({
        path: path,
      });
    },
    getTitle(title) {
      //中英文切换
      let str = "lang." + title;
      return this.$t(str);
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 768px) {
  .about-nav::v-deep{
      margin: 0.5rem 1rem 1rem 3px !important;
      .left-nav {
        width: 25rem ;
      }
  }
}
</style>